<template>

    <div :class=" overflowClasses ">

        <div v-for=" ( route, routeKey ) in relevantRoutes " class="overflow-item" :key=" routeKey " @click=" overflowRoute( route.name )">

            {{ route.title }}
            <font-awesome-icon class="overflow-icon" :icon=" route.icon " />
        </div>
        <div class="overflow-item" @click=" refreshApp() ">

            Refresh App
            <font-awesome-icon class="overflow-icon" icon="sync-alt" />
        </div>
        <div class="overflow-item" @click=" signout() ">

            Logout
            <font-awesome-icon class="overflow-icon" icon="sign-out-alt" />
        </div>
    </div>
</template>


<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'overflow-menu',
        computed: {

            ...mapGetters({

                overflowOpen   : 'nav/overflowOpen',
                routes         : 'nav/routes',
                installableApp : 'pwa/installableApp'
            }),
            relevantRoutes: function(){

                let routes = this.routes.filter( route => {

                    if( route.name == 'install-webapp' ){ // a way too conditionally show menu items

                        if( !this.installableApp ) return;
                    }

                    return route.onOverflow;
                });
                return routes.sort( ( a, b ) => a.displaySequence - b.displaySequence );
            },
            overflowClasses: function(){

                const base = [ 'overflow-wrapper' ];
                base.push( ( this.overflowOpen ) ? 'overflow-open' : 'overflow-close' );

                return base.join( ' ' );
            }
        },
        methods: {

            ...mapActions({

                signout: 'auth/signout'
            }),
            overflowRoute( destination ){

                this.$store.dispatch( 'nav/toggleOverflow' );
                this.$store.dispatch( 'orderMenu/clearState', true );
                this.$router.push( { name: destination } );
            },
            refreshApp(){

                window.location.reload( true )
            }
        },
        components: {

            FontAwesomeIcon
        },
    }
</script>

<style scoped>

    .overflow-wrapper {

        display: flex;
        flex-direction: column;
        position: fixed;

        background-color: white;
        right: 0px;
        height: auto;
        width: auto;
        border-top: 1px solid #333;
        border-left: 1px solid #333;
        border-top-left-radius: 5px;
        padding: 5px 0px;

        transition: bottom 0.2s;
        z-index: 275;
    }
    .overflow-open {

        bottom: 65px;
    }
    .overflow-close {

        bottom: -375px;
    }

    .overflow-item {

        display: flex;
        align-items: center;
        justify-content: flex-end;

        height: 45px;
        padding: 0px 15px;
        min-width: 200px;
        font-size: 22px;
    }
    .overflow-item:hover {

        background-color: rgba(204, 204, 204, 0.5);
    }

    .overflow-icon {

        margin-left: 10px;
    }
</style>